import * as React from "react";

import { Context } from "../Context";

export function Header() {
  const context: any = React.useContext(Context);
  const bio = context.data.bio;
  return (
    <header>
      <div className="background">
        <img className="bgimg" src="img/start/1.jpg" alt="Image" data-displacement="2.jpg" />
        <img className="bgimg" src="img/start/2.jpg" alt="Image" data-displacement="8.jpg" />
        <img className="bgimg" src="img/start/3.jpg" alt="Image" data-displacement="4.jpg" />
        <div className="foreground">
          <div className="row">
            <div className="small-12 bio">
              <div className="headshot">
                <img src="/img/me_2.jpg" />
              </div>
              <h1>{bio.name}</h1>
              <p>
                <strong>{bio.title}</strong>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="small-12">
              <p className="roles">{bio.roles}</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
